import React, { useState, useEffect } from "react";
import { Modal, Input, Select, Icon, Row, Col, Checkbox, Tooltip } from "antd";
import TruncatedText from "../TruncatedText";
import { CheckBookIcon } from "../../../common/CustomIcon";

const { Option } = Select;
const { TextArea } = Input;

// Longer codes first so e.g. "91" wins over "9".
// Only used to insert a space after a dial code once the user types more digits.
const COUNTRY_DIAL_CODES = [
  "971", "966", "852", "91", "86", "81", "61", "49", "44", "33", "1",
];

const formatEmergencyResponseNumber = (input) => {
  if (input == null || input === "") return "";
  const digits = String(input).replace(/[^\d]/g, "");
  if (!digits) return "";

  const matchedCode = COUNTRY_DIAL_CODES.find((code) => digits.startsWith(code));
  if (!matchedCode) return digits;

  const rest = digits.slice(matchedCode.length);
  // Keep only the dial code (no forced trailing space) until more digits are typed,
  // so the user can clear/edit the field freely.
  return rest ? `${matchedCode} ${rest}` : matchedCode;
};

function UN_Number(props) {
  const {
    visible,
    onCancel,
    onSave,
    unSource = [],
    unNumber,
    selectedUN,
    setSelectedUN,
    hazmatClass,
    emergencyResponseNumber,
    description,
    setHazmatClass,
    setEmergencyResponseNumber,
    setDescription,
    isEditing = false,
    pkgGroup,
    setPkgGroup,
    isPlacard,
    setIsPlacard,
    isEditMode = true,
    reqLoading
  } = props;
  const [validationError, setValidationError] = useState([]);

  // useEffect(() => {
  //   if (visible) {
  //     if (isEditing && unNumber) {
  //       const data = typeof unNumber === 'string' ? { un_number: unNumber } : unNumber;
  //       setSelectedUN(data.un_number || "");
  //     } else {
  //       setSelectedUN("");
  //       setHazmatClass("");
  //       setEmergencyResponseNumber("");
  //       setPkgGroup("");
  //       setIsPlacard(false);
  //       setDescription("");
  //     }
  //     setValidationError("");
  //   }
  // }, [visible, isEditing, unNumber]);

  const handleSave = () => {
    if (!selectedUN) {
      setValidationError((prev) => ({ ...prev, selectedUN: "Please select UN Number" }));
      return;
    }
    if (!hazmatClass) {
      setValidationError((prev) => ({ ...prev, hazmatClass: "Please select Hazmat Class" }));
      return;
    }
    // if (!pkgGroup) {
    //   setValidationError((prev) => ({ ...prev, pkgGroup: "Please select Packing Group" }));
    //   return;
    // }
    onSave({
      un_number: selectedUN,
      hazmat_class: hazmatClass,
      packing_group: pkgGroup,
      is_placard_required: isPlacard === true || isPlacard === "true" ? 'true' : 'false',
      emergency_response_number: emergencyResponseNumber,
      description,
    });
    setValidationError("");
  };

  const handleChangeUnDetails = (value) => {
      setSelectedUN(value);

      const filteredData = unSource.find(
          (val) => val.un_number === value
      );
      setHazmatClass(filteredData?.hazard_class);
      setPkgGroup(filteredData?.packing_group);
      setDescription(filteredData?.description)
  };

  const uniqueHazmatClasses = Array.from(
    new Set(
      unSource
        .map((un) => un.hazard_class)
        .concat(hazmatClass ? [hazmatClass] : [])
        .filter((val) => val !== undefined && val !== null && val !== "")
    )
  );

  const uniquePkgGroups = Array.from(
    new Set(
      unSource
        .map((un) => un.packing_group)
        .concat(pkgGroup ? [pkgGroup] : [])
        .filter((val) => val !== undefined && val !== null && val !== "")
    )
  );

  return (
    <Modal
      title={isEditing ? "Edit UN Number" : "Add UN Number"}
      visible={visible}
      onCancel={onCancel}
      onOk={handleSave}
      okText="Save"
      cancelText="Cancel"
      width={700}
      destroyOnClose
      confirmLoading={!isEditMode ? reqLoading : false}
      // footer={isEditMode ? undefined : null}
    >
      <Row gutter={16} type="flex">
        <Col style={{ flex: 1 }} span={8}>
          <div style={{ marginBottom: 16 }}>
            <label>
              UN Number <span style={{ color: "red" }}>*</span>
            </label>

            <Select
              showSearch
              allowClear
              value={selectedUN || undefined}
              placeholder="Select UN Number"
              style={{ width: "100%", marginTop: 4 }}
              onChange={value => {
                handleChangeUnDetails(value);
                setValidationError("");
              }}
              suffixIcon={<Icon style={{ color: "#576EC1" }} type="caret-down" />}
              filterOption={(input, option) =>
                (option.props["data-search"] || "").toLowerCase().includes(input.toLowerCase())
              }
              // disabled={!isEditMode}
            >
              {unSource.map(un => (
                <Option
                  key={un.un_number}
                  value={un.un_number}
                  data-search={`${un.un_number}`}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    {un.placard_logo && (
                      <img
                        src={un.placard_logo}
                        alt=""
                        style={{
                          width: 20,
                          height: 20,
                        }}
                      />
                    )}

                    <TruncatedText
                      text={`${un.un_number}`}
                      style={{
                        color: "#1A354D",
                        fontWeight: 500,
                      }}
                    />
                  </div>
                </Option>
              ))}
            </Select>

            {validationError && (
              <div
                style={{
                  color: "#F5222D",
                  marginTop: 4,
                  fontSize: 12,
                }}
              >
                {validationError?.selectedUN}
              </div>
            )}
          </div>
        </Col>

       <Col style={{ flex: 1 }} span={8}>
          <div style={{ marginBottom: 16 }}>
            <label>Hazmat Class</label>
            <Select
              showSearch
              value={hazmatClass || undefined}
              placeholder="Select Hazmat Class"
              style={{ width: "100%", marginTop: 4 }}
              onChange={value => {
                setHazmatClass(value || "");
              }}
              suffixIcon={<Icon style={{ color: "#576EC1" }} type="caret-down" />}
              filterOption={(input, option) =>
                String(option.props.children || "").toLowerCase().includes(input.toLowerCase())
              }
            >
              {uniqueHazmatClasses.map(hClass => (
                <Option key={hClass} value={hClass}>
                  {String(hClass)}
                </Option>
              ))}
            </Select>
            {validationError && (
              <div
                style={{
                  color: "#F5222D",
                  marginTop: 4,
                  fontSize: 12,
                }}
              >
                {validationError.hazmatClass}
              </div>
            )}
          </div>
        </Col>

         <Col style={{ flex: 1 }} span={8}>
          <div style={{ marginBottom: 16 }}>
            <label>Packing Group
            </label>
            <Select
              showSearch
              value={pkgGroup || undefined}
              placeholder="Select Packing Group"
              style={{ width: "100%", marginTop: 4 }}
              onChange={value => {
                setPkgGroup(value || "");
              }}
              suffixIcon={<Icon style={{ color: "#576EC1" }} type="caret-down" />}
              filterOption={(input, option) =>
                String(option.props.children || "").toLowerCase().includes(input.toLowerCase())
              }
            >
              {uniquePkgGroups.map(pGroup => (
                <Option key={pGroup} value={pGroup}>
                  {String(pGroup)}
                </Option>
              ))}
            </Select>
              {/* {validationError && (
              <div
                style={{
                  color: "#F5222D",
                  marginTop: 4,
                  fontSize: 12,
                }}
              >
                {validationError.pkgGroup}
              </div>
            )} */}
          </div>
        </Col>
      </Row>

      <Row gutter={16} type="flex">
        <Col span={12} style={{ flex: 1 }}>
          <div style={{ marginBottom: 16 }}>
            <label
              style={{
                display: "block",
                marginBottom: 5,
                fontWeight: 500,
              }}
            >
              Emergency Response Number
            </label>

            <Input
              value={emergencyResponseNumber || ""}
              placeholder="Enter emergency response number"
              style={{ width: "100%", height: "32px" }}
              allowClear
              onChange={(e) => {
                setEmergencyResponseNumber(
                  formatEmergencyResponseNumber(e.target.value)
                );
              }}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </div>
        </Col>

        <Col span={12} style={{ flex: 1 }}>
          <label style={{ display: "flex", alignItems: "center", marginTop: 30 }}>
            <Checkbox 
              checked={isPlacard}
              onChange={(e) => {
                setIsPlacard(!isPlacard);
              }}
              >
            <span style={{ marginLeft: 8 }}>Requires Placard</span>
            </Checkbox>
          </label>
        </Col>
      </Row>

      <div>
        <label>Description</label>
        <TextArea
          rows={4}
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder="Enter Description"
          style={{ marginTop: 4 }}
        />
      </div>
    </Modal>
  );
}

export default UN_Number;
